var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsFireIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-950 -284) translate(682 197) translate(29 87) translate(239)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.878,
    r: 12,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.61 13.14c-1.178-3.06-5.37-3.225-4.358-7.673.036-.148-.02-.304-.144-.394-.123-.09-.288-.098-.419-.019-3.225 1.75-4.55 5.695-3.038 9.038.062.154.015.33-.115.433-.13.102-.313.107-.448.01-1.078-.845-1.607-2.212-1.378-3.562.02-.172-.079-.336-.241-.396-.162-.06-.345-.003-.442.141C6.305 11.901 5.948 13.27 6 14.655c.149 2.857 2.281 5.217 5.108 5.655 1.859.32 3.765-.192 5.213-1.4 1.591-1.466 2.105-3.766 1.289-5.77zm-6.96 3.773c.881-.182 1.577-.858 1.785-1.733.248-1.073-.72-2.123-.068-3.818.248 1.4 2.453 2.28 2.453 3.81.06 1.899-1.995 3.526-4.17 1.741z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFireIc);
export default __webpack_public_path__ + "static/media/icons-fire-ic.ab7dc955c06c94b883e472fee3d56867.svg";
export { ForwardRef as ReactComponent };